'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_LAWS_REQUEST: 'FETCH_LAWS_REQUEST',
    FETCH_LAWS_SUCCEEDED: 'FETCH_LAWS_SUCCEEDED',
    FETCH_LAWS_FAILED: 'FETCH_LAWS_FAILED',
    UPDATE_LAW_DATE_REQUEST: 'UPDATE_LAW_DATE_REQUEST',
    UPDATE_LAW_DATE_SUCCEEDED: 'UPDATE_LAW_DATE_SUCCEEDED',
    UPDATE_LAW_DATE_FAILED: 'UPDATE_LAW_DATE_FAILED'
};

function fetchLawsRequest() {
    return {
        type: actionTypes.FETCH_LAWS_REQUEST
    };
}

function fetchLawsSucceeded(laws) {
    return {
        type: actionTypes.FETCH_LAWS_SUCCEEDED,
        laws: laws
    };
}

function fetchLawsFailed() {
    return {
        type: actionTypes.FETCH_LAWS_FAILED
    };
}

function updateLawDateRequest(id, lastUpdatedAt) {
    return {
        type: actionTypes.UPDATE_LAW_DATE_REQUEST,
        id: id,
        lastUpdatedAt: lastUpdatedAt
    };
}

function updateLawDateSucceeded(law) {
    return {
        type: actionTypes.UPDATE_LAW_DATE_SUCCEEDED,
        law: law
    };
}

function updateLawDateFailed(error) {
    return {
        type: actionTypes.UPDATE_LAW_DATE_FAILED,
        error: error
    };
}

var actionCreators = {
    fetchLawsRequest: fetchLawsRequest,
    fetchLawsSucceeded: fetchLawsSucceeded,
    fetchLawsFailed: fetchLawsFailed,
    updateLawDateRequest: updateLawDateRequest,
    updateLawDateSucceeded: updateLawDateSucceeded,
    updateLawDateFailed: updateLawDateFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/laws.js
// module id = 107
// module chunks = 0